export const environment = {
	production: true,
	appCode: 'Champigny-admin',
	appVersion: '1',
	languages: ['en', 'fr'],
	appName: 'Champigny',
	login: {
		redirection: [''],
	},
	logout: {
		redirection: ['session', 'sign-in'],
	},
	api: {
		uri: 'https://api.champigny.appymax.com/v1',
		adminPath: '/admin',
	},
	images: {
		uri: 'https://s3.appymax.com/champigny/',
	},
	plugins: {
		quickForm: {
			enabled: true,
		},
	},
};
